import { Capacitor } from '@capacitor/core';

type UsePlatformReturnType = {
  platform: 'android' | 'ios' | 'web';
  isNative: boolean;
  isWeb: boolean;
  isAndroid: boolean;
  isIOS: boolean;
};

export const usePlatform = (): UsePlatformReturnType => {
  return {
    platform: Capacitor.getPlatform() as 'android' | 'ios' | 'web',
    isNative: Capacitor.isNativePlatform(),
    isWeb: !Capacitor.isNativePlatform(),
    isAndroid: Capacitor.getPlatform() === 'android',
    isIOS: Capacitor.getPlatform() === 'ios',
  };
};
